var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPerms(_vm.perms))?_c('el-button',{attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v("\r\n\t  "+_vm._s(_vm.label)+"\r\n\t")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e0da7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/permission/PreButtom1.vue
// module id = null
// module chunks = 